// The shared pieces every view draws with (base.css), so a section, a status word, a figure or a bar is
// drawn one way everywhere: the consolidation the prototype needed (Seth, 23 Oct).
import type { ReactNode } from 'react';
// Section, Figures, Label and Meter have their own folders now (BL-189); they're here too, for the views
// that import them
export { Section, type SectionProps } from './patterns/Section/Section.tsx';
export { Figure, Figures, type FigureItem, type FigureProps } from './components/Figures/Figures.tsx';
export { Label, type LabelKind, type LabelProps } from './components/Label/Label.tsx';
export { Meter, type Mark, type MeterProps } from './components/Meter/Meter.tsx';

/** An action. In the office it's an underlined word (or the one filled primary); in a chat a tap target. */
export function Action(p: { primary?: boolean; onClick?: () => void; children: ReactNode; label?: string }) {
  return (
    <button
      type="button"
      className={`flw-btn${p.primary ? ' flw-btn-pri' : ''}`}
      onClick={p.onClick}
      aria-label={p.label}
    >
      {p.children}
    </button>
  );
}

export function Facts({ rows }: { rows: [string, ReactNode][] }) {
  return (
    <dl className="flw-facts">
      {rows.map(([k, v]) => [<dt key={`${k}-k`}>{k}</dt>, <dd key={`${k}-v`}>{v}</dd>])}
    </dl>
  );
}
